<template>
    <v-container fluid>
        <div>
            <s-crud title="Imprimir Etiquetas Lotes Abastecidos" :filter="filter" :config="config" no-full search-input
                ref="LotsSupplying" height="calc(98vh - 250px)"
                :group-by="['UwoCustomerName', 'TypeDestinyPacking', 'CmaID']" @rowSelected="rowSelected($event)">
                <!-- :single-row="false" -->

                <!-- <template v-slot:UwoCustomerName="{ row }"> -->
                <!-- <template v-slot:[`item.UwoCustomerID`]="{ item }">
                    {{ item.UwoCustomerID }} - {{ item.UwoCustomerName }}
                </template> -->

                <template v-slot:Actions="{ row }">
                    <v-btn @click="printLabel(row)" dark x-small color="black" class="rounded-lg">
                        <v-icon color="white">mdi-printer</v-icon>
                    </v-btn>
                </template>

                <!-- filtros en el scrud por fechas -->
                <template v-slot:filter>
                    <v-container fluid>
                        <v-row justify="start">

                            <v-col cols="12" md="4" lg="3">
                                <s-select-definition label="Destino" :def="1181" v-model="filter.OrdAreProduction"
                                    id="DedDescription">
                                </s-select-definition>
                            </v-col>

                            <v-col cols="12" md="4" lg="3">
                                <s-date label="Fecha Inicio" v-model="filter.cDateInitial">
                                </s-date>
                            </v-col>

                            <v-col cols="12" md="4" lg="3">
                                <s-date v-model="filter.cDateFin" label="Fecha Fin">
                                </s-date>
                            </v-col>

                        </v-row>

                        <!-- <v-row justify="center">
                            <v-col cols="6" md="4" lg="3">
                                <s-select-definition clearable :def="1172" label="Tipo Cultivo"
                                    v-model="filter.TypeCrop" />
                            </v-col>
                            <v-col cols="6" md="4" lg="3">
                                <s-select-definition clearable :def="1173" label="Cultivo"
                                    v-model="filter.TypeCultive" />
                            </v-col>

                            <v-col cols="12" md="4" lg="3">
                                <s-select-variety clearable :cultiveID="filter.TypeCultive" label="Variedad" full
                                    v-model="filter.VrtID" />
                            </v-col>
                        </v-row> -->
                    </v-container>
                </template>
            </s-crud>
        </div>

        <!-- Modal de Mapeo de Variables -->
        <v-dialog v-model="modalVariableMapping" max-width="750px" persistent v-if="modalVariableMapping">
            <v-card class="rounded-xl elevation-10">
                <v-card-title class="headline blue-grey darken-4 white--text py-3">
                    <v-icon left color="white">mdi-account-outline</v-icon>
                    <span>
                        {{ currentRowToPrint ? currentRowToPrint.UwoCustomerName : 'Mapeo de Variables' }}
                        <span v-if="currentRowToPrint && currentRowToPrint.UwoCustomerID"
                            class="caption ml-2 grey--text text--lighten-2">
                            ({{ currentRowToPrint.UwoCustomerID }})
                        </span>
                    </span>
                </v-card-title>
                <v-card-text class="pa-3 pt-4">
                    <div class="mb-3 d-flex align-center">
                        <v-icon color="primary" class="mr-2">mdi-info-outline</v-icon>
                        <span class="subtitle-2 font-weight-medium grey--text text--darken-3">
                            La plantilla seleccionada requiere las siguientes variables. Selecciona el campo origen para
                            inyectar su valor real:
                        </span>
                    </div>

                    <!-- Información de la Fila Seleccionada -->
                    <v-row dense class="grey lighten-5 rounded-lg pa-2 border mx-0">
                        <v-col cols="6" sm class="py-1">
                            <div class="caption font-weight-bold grey--text text-uppercase">Cultivo</div>
                            <div class="body-2 font-weight-bold text-truncate grey--text text--darken-4">
                                {{ currentRowToPrint.TypeCultiveName || 'N/A' }}
                            </div>
                        </v-col>
                        <v-col cols="6" sm class="py-1">
                            <div class="caption font-weight-bold grey--text text-uppercase">Tipo Cultivo</div>
                            <div class="body-2 font-weight-bold text-truncate grey--text text--darken-4">
                                {{ currentRowToPrint.TypeCropName || 'N/A' }}
                            </div>
                        </v-col>
                        <v-col cols="6" sm class="py-1">
                            <div class="caption font-weight-bold grey--text text-uppercase">Variedad</div>
                            <div class="body-2 font-weight-bold text-truncate grey--text text--darken-4">
                                {{ currentRowToPrint.VrtName || 'N/A' }}
                            </div>
                        </v-col>
                        <v-col cols="6" sm class="py-1">
                            <div class="caption font-weight-bold grey--text text-uppercase">Marca Caja</div>
                            <div class="body-2 font-weight-bold text-truncate grey--text text--darken-4">
                                {{ currentRowToPrint.Brand || 'N/A' }}
                            </div>
                        </v-col>
                        <v-col cols="6" sm class="py-1">
                            <div class="caption font-weight-bold grey--text text-uppercase">Calibre</div>
                            <div class="body-2 font-weight-bold text-truncate grey--text text--darken-4">
                                {{ currentRowToPrint.TypeCaliberName || 'N/A' }}
                            </div>
                        </v-col>
                        <v-col cols="6" sm class="py-1">
                            <div class="caption font-weight-bold grey--text text-uppercase">Peso</div>
                            <div class="body-2 font-weight-bold text-truncate grey--text text--darken-4">
                                {{ currentRowToPrint.Weighed || 'N/A' }} KG
                            </div>
                        </v-col>
                    </v-row>

                    <v-simple-table dense fixed-header class="elevation-1 rounded-lg border table-scroll-mapping">
                        <template v-slot:default>
                            <thead>
                                <tr class="grey lighten-4">
                                    <th class="text-left font-weight-bold py-3"
                                        style="width: 35%; max-width: 250px; font-size: 13px;">
                                        Variable Requerida</th>
                                    <th class="text-left font-weight-bold py-3"
                                        style="width: 65%; max-width: 300px; font-size: 13px;">
                                        Campo Origen (Fila Seleccionada)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="variable in requiredVariables" :key="variable" class="hover-row">
                                    <td class="py-3" style="width: 35%; max-width: 250px; overflow: hidden;">
                                        <div class="font-weight-bold subtitle-1 primary--text text-truncate"
                                            :title="variable">{{ variable }}</div>
                                        <div class="caption mt-1 d-flex align-center">
                                            <span class="grey--text mr-1">Valor real:</span>
                                            <v-chip x-small color="grey lighten-3"
                                                class="font-weight-bold black--text text-truncate"
                                                style="max-width: 180px;" :title="getMappedValuePreview(variable)">
                                                {{ getMappedValuePreview(variable) }}
                                            </v-chip>
                                        </div>
                                    </td>
                                    <td class="py-2" style="width: 65%; max-width: 350px;">
                                        <v-textarea v-if="isProductVariable(variable)"
                                            v-model="variableMappings[variable]"
                                            placeholder="Ingresar nombre del producto personalizado" dense outlined
                                            rows="2" auto-grow hide-details class="rounded-lg" style="max-width: 100%;">
                                        </v-textarea>
                                        <v-autocomplete v-else v-model="variableMappings[variable]"
                                            :items="rowKeysOptions" placeholder="Seleccionar campo" dense outlined
                                            single-line hide-details class="rounded-lg" clearable
                                            style="max-width: 100%;">
                                            <template v-slot:selection="{ item }">
                                                <span class="font-weight-medium primary--text text-truncate">
                                                    {{ item.text ? item.text.split(' (Valor:')[0] : item.value }}
                                                </span>
                                            </template>
                                        </v-autocomplete>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>

                    <!-- Cantidad de Etiquetas y Acciones -->
                    <v-row class="mt-4 px-2" align="center">
                        <v-col cols="12" class="py-0">
                            <div class="d-flex align-center justify-space-between pa-2 rounded-lg border flex-wrap"
                                style="background-color: #f8fafc; border-color: #e2e8f0 !important; gap: 8px;">
                                <!-- Izquierda: Input de Copias -->
                                <div class="d-flex align-center">
                                    <v-icon color="black" class="mr-2" size="28">mdi-printer-settings</v-icon>
                                    <span class="caption font-weight-bold grey--text text-uppercase mr-2">Copias:</span>
                                    <div style="max-width: 95px;">
                                        <v-text-field v-model.number="labelCount" type="number" min="1" outlined dense
                                            hide-details class="rounded-lg font-weight-bold white"
                                            color="primary"></v-text-field>
                                    </div>
                                </div>
                                <!-- Centro: Total de Impresiones -->
                                <div class="text-center d-flex flex-column align-center justify-center">
                                    <span class="caption font-weight-medium grey--text text-uppercase"
                                        style="line-height: 1;">Total etiquetas:</span>
                                    <div class="headline font-weight-black primary--text mt-1" style="line-height: 1;">
                                        {{
                                            labelCount || 0 }}</div>
                                </div>
                                <!-- Derecha: Acciones -->
                                <div class="d-flex align-center">
                                    <v-btn color="error" @click="modalVariableMapping = false"
                                        class="text-none font-weight-bold rounded-lg mr-2" dark depressed>
                                        Cancelar
                                    </v-btn>
                                    <v-btn color="primary" @click="confirmVariableMapping"
                                        class="text-none font-weight-bold rounded-lg px-4" depressed>
                                        Visualizar en Editor
                                    </v-btn>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Modal del Editor Zebra -->
        <v-dialog v-if="modalEditorZebra" v-model="modalEditorZebra" fullscreen persistent>
            <zebra-editor :label-data="zebraEditorPropData" :label-count.sync="labelCount"
                @close="modalEditorZebra = false" @print-complete="onPrintComplete"></zebra-editor>
        </v-dialog>
    </v-container>
</template>
<script>
import _sPrintTemplateLotsSupplying from "@/services/FreshProduction/PrintTemplateLotsSupplyingService";
import _sPrinterHistoryTemplate from "@/services/FreshProduction/PrfPrinterHistoryTemplateService";
import SSelectVariety from "@/components/HarvestSchedule/SSelectVariety";
import _sPrfCustomerTemplateService from "@/services/FreshProduction/PrfCustomerTemplateService";
import _sPrfCustomerTemplatePtiService from "@/services/FreshProduction/PrfCustomerTemplatePtiService";
import _sPrfCustomerTemplateVariantService from "@/services/FreshProduction/PrfCustomerTemplateVariantService";
import ZebraEditor from "../CustomerTemplate/ZebraEditor.vue";

export default {
    components: {
        SSelectVariety,
        ZebraEditor,
    },
    data: () => ({
        labelCount: 1,
        disableButtonSampling: true,
        SppIdsArray: [],
        palletsSelection: [],
        SppIdsArrayString: "",
        DataSupplyingDetail: [],
        ptiCodesList: [],
        variantTemplatesList: [],
        modalVariableMapping: false,
        modalEditorZebra: false,
        requiredVariables: [],
        rowKeysOptions: [],
        variableMappings: {},
        zebraEditorPropData: null,
        currentRowToPrint: null,
        currentTemplateString: null,
        /* caliberFil: "", */
        filter: {
            cDateInitial: "",
            cDateFin: "",
            OrdAreProduction: "USA",
            // TypeCrop: 0,
            // TypeCultive: 0,
            // VrtID: 0
            /* caliberFilter: 0, */
        },
        config: {
            service: _sPrintTemplateLotsSupplying,
            model: {
                PldID: "ID",
                PltDate: "date",
                // PltDate: "datetime",
                Actions: "",
            },
            headers: [
                { text: "Accion", value: "Actions", width: 60 },
                { text: "Cliente", value: "UwoCustomerName", width: 200 },
                { text: "Fec. Empaque", value: "PltDate", width: 110 },
                { text: "Orden Producción", value: "UwoOrderProductionID", width: 100 },
                { text: "Lote Producción.", value: "RcfID", width: 100 },
                { text: "Destino Empaque", value: "TypeDestinyPacking", width: 100 },
                { text: "Linea Negocio", value: "TypeBsnLineName", width: 100 },
                { text: "Marca", value: "Brand", width: 100 },
                { text: "Peso (KG)", value: "Weighed", width: 70 },
                { text: "Cultivo", value: "TypeCultiveName", width: 100 },
                { text: "Tipo cultivo", value: "TypeCropName", width: 150 },
                { text: "Variedad", value: "VrtName", width: 100 },
                // { text: "Tarima", value: "ScfCode", width: 100 },
                // { text: "Parihuela.", value: "LlpID", width: 100 },
                { text: "Calibre", value: "TypeCaliberName", width: 100 },
                { text: "Cant. Cajas", value: "PldQuantityBoxes", width: 100 },
                { text: "Zona", value: "TypeZonLocationName", width: 100 },
                { text: "Campaña", value: "CmaName", width: 150 },
                { text: "Contador Impresión", value: "CounterPagesPrinted", width: 100 },

            ],
        },
    }),

    created() {
        this.filter.cDateInitial = this.$fun.getDate();
        this.filter.cDateFin = this.$fun.getDate();
    },

    watch: {
        "filter.OrdAreProduction": function (val) {
            console.log(val);
        },
    },

    methods: {
        printLabel(row) {
            this.labelCount = parseInt(row.PldQuantityBoxes, 10) || 1;
            row.objectPTI = null;
            row.template = null;
            row.templateVariant = null;
            console.log("Imprimir etiqueta:", JSON.parse(JSON.stringify(row)));
            const requestID = this.$fun.getUserID();

            this.ptiCodesList = [];
            this.variantTemplatesList = [];

            const getTemplates = (cardCode) => {
                const params = {
                    filter: {}, draw: 1, start: 0, length: -1,
                    order: [{ dir: "", column: "" }], searchText: cardCode,
                };

                return _sPrfCustomerTemplateService.pagination(params, requestID);
            };


            const getCodesPTI = (cardCode) => {
                const ptiParams = {
                    filter: { UwoCustomerID: cardCode }, draw: 1, start: 0, length: -1,
                    order: [{ dir: "", column: "" }], searchText: "",
                };

                return _sPrfCustomerTemplatePtiService.pagination(ptiParams, requestID);
            };

            getTemplates(row.UwoCustomerID).then(resp => {
                let templates = resp.status === 200 && resp.data && resp.data.data ? resp.data.data : [];

                if (templates.length === 0 && row.UwoCustomerID !== "*") {
                    return getTemplates("*");
                }
                return { data: { data: templates } };
            }).then(resp => {
                const templates = resp && resp.data && resp.data.data ? resp.data.data : [];
                if (templates.length === 0) {
                    console.log("No se encontró plantilla de cliente para:", row.UwoCustomerID);
                    return;
                }

                let matchedTemplate = templates[0];
                const rowDestiny = row.TypeDestinyPacking;
                const rowBsnLine = row.TypeBsnLine;

                // console.log(JSON.parse(JSON.stringify({ templates })))
                const bestMatch = templates.find(t => {
                    let match = true;
                    if (rowDestiny && t.TypeDestinyName && t.TypeDestinyName != rowDestiny) match = false;
                    if (rowBsnLine && t.TypeBsnLine && t.TypeBsnLine != rowBsnLine) match = false;
                    return match;
                });

                if (bestMatch) {
                    matchedTemplate = bestMatch;
                    row.template = bestMatch;
                }

                const ctmpID = matchedTemplate.CtmpID;
                console.log("Plantilla Cliente encontrada con ID:", ctmpID, matchedTemplate);

                const ptiPromise = getCodesPTI(row.UwoCustomerID).then(ptiResp => {
                    const ptiCodes = ptiResp.status === 200 && ptiResp.data && ptiResp.data.data ? ptiResp.data.data : [];
                    const match = this.findMatchedPtiCode(row.UwoCustomerID, row, ptiCodes);

                    if (!match && row.UwoCustomerID !== "*") {
                        console.log("No se encontró coincidencia de código PTI para el cliente, buscando general (*)...");
                        return getCodesPTI("*").then(generalResp => {
                            const generalPtiCodes = generalResp.status === 200 && generalResp.data && generalResp.data.data ? generalResp.data.data : [];
                            const generalMatch = this.findMatchedPtiCode("*", row, generalPtiCodes);
                            return { ptiCodes: generalPtiCodes, match: generalMatch };
                        });
                    }

                    return { ptiCodes, match };
                }).then(({ ptiCodes, match }) => {
                    this.ptiCodesList = ptiCodes;
                    // console.log("Códigos PTI cargados:", JSON.parse(JSON.stringify(this.ptiCodesList)));
                    console.log("PTI exacto encontrado:", JSON.parse(JSON.stringify(match)));
                    if (match) {
                        row.objectPTI = match;
                    }
                }).catch(err => {
                    console.error("Error al cargar códigos PTI:", err);
                });

                const variantParams = {
                    filter: { CtmpID: ctmpID }, draw: 1, start: 0, length: -1,
                    order: [{ dir: "", column: "" }], searchText: "",
                };

                const variantPromise = _sPrfCustomerTemplateVariantService.pagination(variantParams, requestID).then(varResp => {
                    this.variantTemplatesList = varResp.status === 200 && varResp.data && varResp.data.data ? varResp.data.data : [];
                    // console.log("Variantes:", JSON.parse(JSON.stringify(this.variantTemplatesList)));

                    const matchedVariant = this.findMatchedVariantTemplate(row, this.variantTemplatesList);
                    console.log("Variante exacta encontrada:", matchedVariant);
                    if (matchedVariant) {
                        row.objectVariant = matchedVariant;
                    }
                }).catch(err => {
                    console.error("Error al cargar plantillas variantes:", err);
                });

                return Promise.all([ptiPromise, variantPromise]).then(() => {
                    // 1. Validar Código PTI
                    if (!row.objectPTI) {
                        this.$fun.alert("No se ha encontrado el código PTI correspondiente.", "warning");
                        return;
                    }

                    let finalTemplate = null;

                    // 2. Validar Plantilla Variante
                    if (row.objectVariant) {
                        if (!row.objectVariant.Template) {
                            this.$fun.alert("La plantilla de la variante encontrada está vacía.", "warning");
                            return;
                        }
                        finalTemplate = row.objectVariant.Template;
                    } else {
                        // 3. Validar Plantilla Principal (objecttemplate)
                        if (!matchedTemplate || !matchedTemplate.Template) {
                            this.$fun.alert("La plantilla principal del cliente está vacía o no existe.", "warning");
                            return;
                        }
                        finalTemplate = matchedTemplate.Template;
                    }

                    // console.log("Plantilla final a utilizar:", finalTemplate);
                    row.Lote = `${row.RcfID}`;
                    row.CodeSenasaAndLote = `${row.FltCodSenasa}-${row.RcfID}`;
                    row.CodeSenasaAndLoteWithSpace = `${row.FltCodSenasa} ${row.RcfID}`;
                    row.GtinName = row.objectPTI.GtinName;
                    row.GeneralPlu = row.objectPTI.GeneralPlu;

                    row.CodePluSticker = (row.objectPTI.CodePluSticker || '').substr(-13);
                    row.PluSticker = row.objectPTI.PluSticker;
                    row.AbreviatureCodePluSticker = row.objectPTI.AbreviatureCodePluSticker;
                    // row.GTIN = row.objectPTI.GtinName;
                    // Generamos codigo menor y mayor
                    const { minor, major } = this.calcularVoiceCode(row.objectPTI.GtinName, row.RcfID, row.DatePackCode);
                    row.VcMinorCode = minor;
                    row.VcMajorCode = major;

                    // Guardamos el row y el template en variables de estado
                    this.currentRowToPrint = row;
                    this.currentTemplateString = finalTemplate;

                    // Parsear el template
                    let parsedTemplate = null;
                    try {
                        parsedTemplate = JSON.parse(finalTemplate);
                    } catch (e) {
                        console.error("Error al parsear el JSON de la plantilla:", e);
                        this.$fun.alert("La plantilla no tiene un formato JSON válido.", "error");
                        return;
                    }

                    // Obtener las variables requeridas
                    this.requiredVariables = this.getTemplateVariables(parsedTemplate);
                    // console.log("Variables requeridas extraídas:", this.requiredVariables);

                    if (this.requiredVariables.length === 0) {
                        // Si no requiere variables, abrimos el editor directamente
                        this.zebraEditorPropData = {
                            Id: row.objectVariant ? `Variant-${row.objectVariant.CtmpvID}` : `General-${row.template.CtmpID}`,
                            Template: finalTemplate
                        };
                        this.modalEditorZebra = true;
                        return;
                    }

                    const keyFriendlyNames = {
                        UwoCustomerID: "Código del Cliente",
                        UwoCustomerName: "Nombre del Cliente",
                        UwoCustomerAddress: "Dirección del Cliente",
                        UwoMaterialListName: "Nombre del producto Terminado",
                        PltDate: "Fecha de Empaque",

                        ShortYearPack: "Año de Empaque en formato corto YY",
                        FullYearPack: "Año de Empaque en formato largo YYYY",
                        ShortMonthPack: "Abreviatura del Mes de Empaque Inglés Abreviatura (Ejm: Jan)",
                        MonthPack: "Mes de Empaque formato corto MM (Ejm: 08)",
                        DayPack: "Día de la fecha del Empaque (Ejm: 31)",
                        DayNumberPack: "Número del día de la semana Empaque",
                        LetterDayPack: "Letra del día de la semana Empaque (Ejm: M)",
                        DatePackCode: "Fecha de Empaque en formato YYMMDD (AñoMesDía)",

                        UwoOrderProductionID: "Orden de Producción",
                        RcfID: "ID Lote Producción",
                        RcfCode: "Código del Lote",
                        TypeDestinyPacking: "Destino de Empaque",
                        TypeBsnLine: "ID Línea de Negocio",
                        TypeBsnLineName: "Línea de Negocio",
                        Brand: "Marca",
                        Weighed: "Peso (KG)",
                        TypeCultive: "ID Cultivo",
                        TypeCultiveName: "Cultivo",
                        TypeCrop: "ID Tipo de Cultivo",
                        TypeCropName: "Tipo de Cultivo",
                        VrtID: "ID Variedad",
                        VrtName: "Variedad",
                        TypeCaliber: "ID Calibre",
                        TypeCaliberName: "Calibre",
                        PldQuantityBoxes: "Cantidad de Jabas",
                        FltID: "ID Lote Productor",
                        FltCodSenasa: "Código Senasa",
                        FagID: "ID del Fundo",
                        FagName: "Nombre del Fundo",
                        TypeZonLocation: "ID Zona Ubicación",
                        TypeZonLocationName: "Nombre Zona Ubicación",
                        TcDescription: "Descripción Adicional",
                        CmaID: "ID Campaña",
                        CmaName: "Campaña",
                        SppID: "ID Abastecimiento",
                        // GTIN: "Código GTIN",
                        // PLU: "Código PLU",

                        Lote: "Lote",
                        CodeSenasaAndLote: "Código Senasa y Lote",
                        CodeSenasaAndLoteWithSpace: "Código Senasa y Lote con espacio",

                        GtinName: "Código GTIN",
                        GeneralPlu: "Código General PLU",

                        CodePluSticker: "Código PLU Sticker",
                        PluSticker: "PLU Sticker",
                        AbreviatureCodePluSticker: "Abreviatura PLU Sticker",

                        GGGCertificateHolder: "GGG Titular Certificado",
                        GGNProducer: "GGN Productor",
                    };

                    // Generar las opciones para los selects de las variables, excluyendo campos que representan objetos o arreglos y campos de plantilla (template)
                    this.rowKeysOptions = Object.keys(row)
                        .filter(k => {
                            const val = row[k];
                            const isObject = val && typeof val === 'object';
                            const isTemplate = k.toLowerCase().includes('template');
                            return !isObject && !isTemplate;
                        })
                        .map(k => {
                            const friendlyName = keyFriendlyNames[k] || k;
                            return {
                                text: `${friendlyName} (Valor: ${row[k]})`,
                                value: k
                            };
                        });

                    // Mapeo automático
                    const mappings = {};
                    this.requiredVariables.forEach(v => {
                        if (this.isProductVariable(v)) {
                            mappings[v] = row.UwoMaterialListName || '';
                        } else {
                            const lowerV = v.toLowerCase();
                            let matchedKey = '';

                            if (lowerV === 'lote') {
                                matchedKey = 'Lote';
                            } else if (lowerV === 'customer' || lowerV === 'cliente' || lowerV === 'uwo_customer_name') {
                                matchedKey = 'UwoCustomerName';
                            } else if (lowerV === 'customer_address' || lowerV === 'direccion' || lowerV === 'direccion_cliente') {
                                matchedKey = 'UwoCustomerAddress';
                            } else if (lowerV === 'caliber' || lowerV === 'calibre') {
                                matchedKey = 'TypeCaliberName';
                            } else if (lowerV === 'weight' || lowerV === 'weighed' || lowerV === 'peso') {
                                matchedKey = 'Weighed';
                            } else if (lowerV === 'brand' || lowerV === 'marca') {
                                matchedKey = 'Brand';
                            } else if (lowerV === 'date_pack' || lowerV === 'date' || lowerV === 'fecha') {
                                matchedKey = 'PltDate';
                            } else if (lowerV === 'variety' || lowerV === 'variedad') {
                                matchedKey = 'VrtName';
                            } else if (lowerV === 'cultive' || lowerV === 'cultivo') {
                                matchedKey = 'TypeCultiveName';
                            } else if (lowerV === 'crop' || lowerV === 'tipo_cultivo') {
                                matchedKey = 'TypeCropName';
                            } else if (lowerV === 'zone' || lowerV === 'zona') {
                                matchedKey = 'TypeZonLocation';
                            } else if (lowerV === 'gtin') {
                                matchedKey = 'GtinName';
                            } else if (lowerV === 'plu' || lowerV === 'code_plu') {
                                matchedKey = 'GeneralPlu';
                            } else if (lowerV === 'code_plu_sticker') {
                                matchedKey = 'CodePluSticker';
                            } else if (lowerV === 'plu_sticker' || lowerV === 'number_plu') {
                                matchedKey = 'PluSticker';
                            } else if (lowerV === 'abrev_plu_sticker' || lowerV === 'abreviatura_codigo_plu' || lowerV === 'indicador_tamanio') {
                                matchedKey = 'AbreviatureCodePluSticker';
                            } else if (lowerV === 'vc_minor_code') {
                                matchedKey = 'VcMinorCode';
                            } else if (lowerV === 'vc_major_code') {
                                matchedKey = 'VcMajorCode';
                            } else if (lowerV === 'codigo_senasa' || lowerV === 'code_senasa' || lowerV === 'senasa_code') {
                                matchedKey = 'FltCodSenasa';
                            } else if (lowerV === 'code_senasa_and_lote' || lowerV === 'codigo_senasa_y_lote') {
                                matchedKey = 'CodeSenasaAndLote';
                            } else if (lowerV === 'code_senasa_and_lote_with_space' || lowerV === 'codigo_senasa_y_lote_con_espacio') {
                                matchedKey = 'CodeSenasaAndLoteWithSpace';
                            } else if (lowerV === 'short_month_pack') {
                                matchedKey = 'ShortMonthPack';
                            } else if (lowerV === 'month_pack') {
                                matchedKey = 'MonthPack';
                            } else if (lowerV === 'date_pack_code') {
                                matchedKey = 'DatePackCode';
                            } else if (lowerV === 'full_year_pack') {
                                matchedKey = 'FullYearPack';
                            } else if (lowerV === 'fruit_box' || lowerV === 'cantidad_x_caja' || lowerV === 'cantidad_caja') {
                                matchedKey = 'PldQuantityBoxes';
                            } else if (lowerV === 'weight_fruit' || lowerV === 'peso_fruta') {
                                matchedKey = 'Weighed';
                            } else if (lowerV === 'day_number_pack') {
                                matchedKey = 'DayNumberPack';
                            } else if (lowerV === 'letter_day_pack') {
                                matchedKey = 'LetterDayPack';
                            } else if (lowerV === 'day_pack') {
                                matchedKey = 'DayPack';
                            } else if (lowerV === 'short_year_pack') {
                                matchedKey = 'ShortYearPack';
                            }


                            if (!matchedKey) {
                                const found = Object.keys(row).find(k => k.toLowerCase() === lowerV);
                                if (found) matchedKey = found;
                            }

                            mappings[v] = matchedKey || '';
                        }
                    });

                    this.variableMappings = mappings;

                    // Abrir el modal de mapeo de variables
                    this.modalVariableMapping = true;
                });
            }).catch(err => {
                console.error("Error en el flujo de impresión:", err);
            });
        },
        findMatchedPtiCode(cardCode, row, ptiList) {
            if (!ptiList || ptiList.length === 0) return null;
            // Replicamos las condiciones del WHERE del Procedure
            const coincidencias = ptiList.filter(p => {
                if (cardCode == '*') { // MOTUPE
                    if (cardCode == '*') return (p.Brand || '').toString().toLowerCase() === (row.Brand || '').toString().toLowerCase() && p.Weighed == row.Weighed && p.TypeCaliber == row.TypeCaliber;
                }
                else {
                    if (p.Brand != '*') return p.TypeCrop == row.TypeCultive && p.TypeCultive == row.TypeCrop && p.Weighed == row.Weighed && p.TypeCaliber == row.TypeCaliber && (p.Brand || '').toString().toLowerCase() === (row.Brand || '').toString().toLowerCase();
                    return p.TypeCrop == row.TypeCultive && p.TypeCultive == row.TypeCrop && p.Weighed == row.Weighed && p.TypeCaliber == row.TypeCaliber;
                }
                return false;
            });

            if (coincidencias.length > 0) {
                return coincidencias[0];
            }

            return null; // Si ninguno cumple todas las condiciones
        },
        findMatchedVariantTemplate(row, variantList) {
            if (!variantList || variantList.length === 0) return null;
            return variantList.find(item => {
                // p.TypeCrop (del pti/variante) == row.TypeCultive (cultivo de la fila debido al mapping invertido en el SP)
                const matchCrop = item.TypeCrop == row.TypeCultive;
                // p.TypeCultive (del pti/variante) == row.TypeCrop (tipo cultivo de la fila)
                const matchCultive = item.TypeCultive == row.TypeCrop;
                // Brand
                const matchBrand = (item.Brand || '').toString().toLowerCase() === (row.Brand || '').toString().toLowerCase();
                return matchCrop && matchCultive && matchBrand;
            });
        },
        isProductVariable(variable) {
            if (!variable) return false;
            const lower = variable.toLowerCase();
            return lower.includes('product_description') ||
                lower.includes('nombre_producto') ||
                lower.includes('producto') ||
                lower.includes('product') ||
                lower.includes('desc_product') ||
                lower.includes('descripcion_producto');
        },
        getTemplateVariables(parsedTemplate) {
            let vars = [];
            if (!parsedTemplate) return vars;

            if (parsedTemplate.variables) {
                if (Array.isArray(parsedTemplate.variables)) {
                    vars = parsedTemplate.variables.map(v => {
                        if (typeof v === 'string') return v;
                        if (v && typeof v === 'object') return v.name || v.key || v.id || '';
                        return '';
                    }).filter(Boolean);
                } else if (typeof parsedTemplate.variables === 'object') {
                    vars = Object.keys(parsedTemplate.variables);
                }
            }

            // Fallback: Buscar marcas dinámicas en las páginas (por ejemplo {LOTE}, ${LOTE}, [LOTE])
            if (vars.length === 0 && parsedTemplate.pages) {
                const zplStr = JSON.stringify(parsedTemplate.pages);
                const matches = zplStr.match(/\{([A-Za-z0-9_]+)\}|\$\{([A-Za-z0-9_]+)\}|\[([A-Za-z0-9_]+)\]/g);
                if (matches) {
                    const cleanMatches = matches.map(m => m.replace(/[\{\}\$\[\]]/g, ''));
                    vars = [...new Set(cleanMatches)];
                }
            }

            return vars;
        },
        flattenObject(obj, prefix = '') {
            let result = {};
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    const value = obj[key];
                    const newKey = prefix ? `${prefix}.${key}` : key;
                    if (value && typeof value === 'object' && !Array.isArray(value) && !(value instanceof Date)) {
                        Object.assign(result, this.flattenObject(value, newKey));
                    } else if (value !== null && value !== undefined) {
                        result[newKey] = value;
                    }
                }
            }
            return result;
        },
        confirmVariableMapping() {
            // Validar que todas las variables tengan un campo de origen asignado
            const unmapped = this.requiredVariables.filter(v => !this.variableMappings[v]);
            if (unmapped.length > 0) {
                this.$fun.alert(
                    `Debe asignar un campo de origen para las siguientes variables: ${unmapped.join(', ')}`,
                    "warning"
                );
                return;
            }

            // Obtener valores reales del row usando las llaves mapeadas
            const mappedData = {};
            const row = this.currentRowToPrint;

            this.requiredVariables.forEach(v => {
                if (this.isProductVariable(v)) {
                    mappedData[v] = this.variableMappings[v] || '';
                } else {
                    const mappedKey = this.variableMappings[v];
                    mappedData[v] = row[mappedKey] !== undefined && row[mappedKey] !== null ? row[mappedKey] : '';
                }
            });

            // Construir el objeto para ZebraEditor.vue
            const templateId = this.currentRowToPrint.objectVariant
                ? `Variant-${this.currentRowToPrint.objectVariant.CtmpvID}`
                : `General-${this.currentRowToPrint.template.CtmpID}`;

            this.zebraEditorPropData = {
                Id: templateId,
                Template: this.currentTemplateString,
                ...mappedData
            };

            console.log("Datos de la etiqueta inyectados al ZebraEditor:", this.zebraEditorPropData);

            // Cerrar el modal de mapeo y abrir el editor Zebra fullscreen
            // this.modalVariableMapping = false;
            this.modalEditorZebra = true;
        },
        onPrintComplete(pages = 1) {
            this.$fun.alert("Impresión completada con éxito.", "success");
            console.log({ pages })
            const object = {
                PrhtID: 0,
                PldID: this.currentRowToPrint?.PldID || 0,
                Pages: pages,
                SecStatus: 1,
                UsrCreateID: this.$fun.getUserID()
            }
            _sPrinterHistoryTemplate.save(object, this.$fun.getUserID()).then(r => {
                if (r && r.status == 200) {
                    console.log("Impresión completada con éxito.");
                } else {
                    console.log("Error al guardar el historial de impresión");
                }
            })
        },
        getMappedValuePreview(variable) {
            if (this.isProductVariable(variable)) {
                return this.variableMappings[variable] || 'Sin asignar';
            }
            const key = this.variableMappings[variable];
            if (!key) return 'Sin asignar';
            const row = this.currentRowToPrint;
            return row[key] !== undefined && row[key] !== null ? row[key] : 'Sin asignar';
        },
        calcularVoiceCode(gtin, lote, fechaFormateada) {

            const CreateCrc16 = () => {
                let polynomial, value, temp;
                let table = new Array(256);
                polynomial = 40961;
                for (let i = 0; i < table.length; ++i) {
                    value = 0;
                    temp = i;
                    for (let j = 0; j < 8; ++j) {
                        if (0 != ((value ^ temp) & 1)) {
                            value = (value >> 1) ^ polynomial
                        } else {
                            value >>= 1
                        }
                        temp >>= 1
                    }
                    table[i] = value
                }
                return table
            }

            // 1. Crear la tabla CRC16 (estándar PTI)
            let crc = 0;
            const table = CreateCrc16();
            const testString = `${gtin}${lote}${fechaFormateada}`;

            for (let i = 0; i < testString.length; ++i) {
                const index = (crc ^ testString.charCodeAt(i)) % 256;
                crc = ((crc >> 8) ^ table[index]) & 0xFFFF;
            }

            // 2. Obtener los 4 dígitos con relleno de ceros
            const vc = String(crc % 10000).padStart(4, '0');

            return {
                fullCode: vc,
                minor: vc.substr(0, 2), // Ej: "04"
                major: vc.substr(2, 2)  // Ej: "82"
            };
        },


        rowSelected(item) {
            this.SppIdsArray = []
            if (item.length > 0) {
                if (item !== undefined) {
                    this.palletsSelection = [];
                    this.disableButtonSampling = false;
                    item.forEach(element => {
                        this.palletsSelection.push(element);
                        if (element.IsTransfer == 0) {
                            this.SppIdsArray.push(element.SppID);
                        }
                    })
                }
            }
        },

        removeSupplyng(item) {


            item.SpdID = item.SppID
            item.SecStatus = 0;
            item.UsrCreateID = this.$fun.getUserID()

            /* let DataHead = {};
            this.DataSupplyingDetail.push(item); */

            /* DataHead.SppID = item.SppID;
            DataHead.LppID = item.LppID;
            DataHead.SppQuantityJaba = item.SpdQuantityJaba;
            DataHead.SecStatus = 1;
            DataHead.TypeDestiny = item.TypeDestiny;
            DataHead.SppState = 1; */

            /* DataHead.DataSupplyingDetail = this.DataSupplyingDetail; */

            console.log("desabastecer", item);

            this.$fun.alert("Seguro que desea desabastecer ?", "question").then(r => {
                if (r.value) {
                    /* _sSupplying.save(item, this.$fun.getUserID()).then(r => {
                        if (r.status == 200) {
                            this.$fun.alert("Desabastecido correctamente", "success");
                            this.$refs.LotsSupplying.refresh();
                        }
                    }); */
                }

            });

        },
    },

};
</script>

<style scoped>
.table-scroll-mapping ::v-deep .v-data-table__wrapper {
    max-height: 400px;
    overflow-y: auto;
}
</style>
